"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var VideoComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(VideoComponent, _React$Component);

  var _super = _createSuper(VideoComponent);

  function VideoComponent() {
    var _this;

    (0, _classCallCheck2["default"])(this, VideoComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      played: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "validateVideoEvents", function () {
      var _this$props = _this.props,
          onVideoEnd = _this$props.onVideoEnd,
          closeModal = _this$props.closeModal,
          closeModalAtEnd = _this$props.closeModalAtEnd;
      var played = _this.state.played;

      if (_this.player) {
        _this.player.on('play', function () {
          if (played === false) {
            _this.setOnPlayEvent();
          }
        });

        _this.player.on('ended', function () {
          onVideoEnd();
          closeModalAtEnd && closeModal();
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setOnPlayEvent", function () {
      var onVideoStart = _this.props.onVideoStart;
      var played = _this.state.played;

      if (played === false) {
        _this.setState({
          played: true
        }, function () {
          onVideoStart && onVideoStart();
        });
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(VideoComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props2 = this.props,
          options = _this$props2.options,
          autoPlay = _this$props2.autoPlay;

      var Plyr = require('plyr');

      this.player = new Plyr('#plyr-player', options);
      this.validateVideoEvents();
      this.player.on('ready', function () {
        return autoPlay && _this2.player.play();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.player.length > 0) {
        var _iterator = _createForOfIteratorHelper(this.player),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var playerEl = _step.value;
            playerEl.destroy();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          videoId = _this$props3.videoId,
          videoProvider = _this$props3.videoProvider;
      return /*#__PURE__*/React.createElement("div", {
        id: "plyr-player",
        "data-plyr-provider": videoProvider,
        "data-plyr-embed-id": videoId
      });
    }
  }]);
  return VideoComponent;
}(React.Component);

(0, _defineProperty2["default"])(VideoComponent, "defaultProps", {
  autoPlay: true,
  closeModal: function closeModal() {},
  closeModalAtEnd: true,
  onVideoEnd: function onVideoEnd() {},
  onVideoStart: function onVideoStart() {},
  options: {}
});
var _default = VideoComponent;
exports["default"] = _default;